<!--用于调试测试的界面-->
<template>
	<div>
		<div class="buttonLine">
			<iconButton icoName="wedoButton/confirm.png" buttonText="启动打印" @buttonClick="printState = 0"></iconButton>
			<iconButton icoName="wedoButton/close.png" buttonText="停止打印" @buttonClick="printState = 1"></iconButton>
			<iconButton icoName="wedoButton/clean.png" buttonText="清空打印" @buttonClick="msgList = [],colorMap = {}"></iconButton>
		</div>
		<div class="flexBetween" style="height: calc(100% - 50px);">
			<div style="height: 80%;">
				<iconButton icoName="wedoButton/send.png" buttonText="测试消息推送" @buttonClick="testPushMessage"></iconButton>
			</div>
			<div style="margin-right: 20px;height: 90%;">
				<p>消息打印：<span style="color: red;">{{printState == 0 ? '开启':'关闭'}}</span></p>
				<div class="custom-scrollbar msg-box">
					<p v-for="(item,index) in msgList" :style="getPStyle(item,index)" :key="index">{{item}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import iconButton from '@/components/module/universal/iconButton.vue'
	export default {
		components: {
			iconButton
		},
		props: {},
		data() {
			return {
				//0打印1暂停
				printState: 0,
				colorMap:{},
				msgList: []
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getPStyle(){
				return (item,index)=>{
					return {
						color:this.colorMap['i'+index]
					}
				}
			}
		},
		watch: {},
		methods: {
			addMsg(msg,color) {
				if (this.printState == 0) {
					this.msgList.push(msg)
					this.$set(this.colorMap,'i'+(this.msgList.length-1),getValueIfNoNull(color,'black'))
				}
			},
			testPushMessage() {
				this.$dialogMethod.openNomalInputDialog('测试事件推送', [{
					name: '指定用户账户',
					pkid: 'userCode',
					type: 0
				}, {
					name: '事件类型',
					pkid: 'type',
					type: 7,
					dataList: [{
						name: '越限告警',
						pkid: 1
					}, {
						name: '变位告警',
						pkid: 2
					}, {
						name: '故障告警',
						pkid: 3
					}, {
						name: '通讯消息',
						pkid: 7
					}, {
						name: '温升报警',
						pkid: 8
					}],
					defaultValue: 0
				}, {
					name: '事件等级',
					pkid: 'level',
					type: 7,
					dataList: [{
						name: '消息',
						pkid: 0
					}, {
						name: '预警',
						pkid: 1
					}, {
						name: '告警',
						pkid: 2
					}],
					defaultValue: 0
				}, ], info => {
					if (info.userCode == undefined || info.userCode.length == 0) {
						this.$dialogMethod.showMessage('用户账号不能为空！')
						return false
					}
					var data = {
						"unitName": "测试单位",
						"eventlevel": info.level.pkid,
						"linkObject": "设备的名称.变量名称",
						"typeName": info.type.name,
						"unitId": "B7759A2694BD4D1AA020B73962BCABB4",
						"description": "这里是事件内容描述，根据不同的类型会有不同的内容",
						"eventtime": 1572539358000,
						"deviceNo": -1,
						"deviceName": "设备名称",
						"uuid": "3710375931907407872"
					}
					this.addMsg("向账号为【{0}】的用户发送等级为【{1}】的【{2}】事件推送".format(info.userCode,info.level.name,info.type.name),'green')
					this.$api.debugApi.pushMsgByUserCode(info.userCode, 4, 0, 0, JSON.stringify(data), Date.now(), respon => {
						this.addMsg(respon)
					}, respon => {
						this.addMsg(respon,'red')
					})
				})
			}
		}
	}
</script>

<style scoped>
	.msg-box {
		height: 90%;
		width: 600px;
		background: white;
		border: #00C6FF 1px solid;
		padding: 10px;
		border-radius: 5px;
	}
	.msg-box>p{
		word-break:break-all;
		border-bottom: gainsboro 1px dashed;
		padding: 5px 0;
	}
</style>
